export default {"src":"/_next/static/media/youtube_icon.c32e47ef.svg","height":66,"width":80,"blurWidth":0,"blurHeight":0};